"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.OrganisationType = void 0;
var react_1 = __importDefault(require("react"));
var OrganisationType = function (_a) {
  var className = _a.className;
  return react_1.default.createElement("svg", {
    className: className,
    width: "16",
    height: "16",
    viewBox: "0 0 48 48"
  }, react_1.default.createElement("g", null, react_1.default.createElement("path", {
    d: "M24,1C11.3,1,1,11.3,1,24c0,12.7,10.3,23,23,23c12.7,0,23-10.3,23-23C47,11.3,36.7,1,24,1z M22,42.9V41h-3v1.3\n      c-1.4-0.4-2.7-0.9-4-1.6V32h18v8.7c-1.3,0.7-2.6,1.2-4,1.6V41h-3v1.9C25.3,43,24.7,43,24,43S22.7,43,22,42.9z M37,37.8V28H11v9.8\n      C7.3,34.4,5,29.4,5,24C5,13.5,13.5,5,24,5s19,8.5,19,19C43,29.4,40.7,34.4,37,37.8z"
  }), react_1.default.createElement("rect", {
    x: "19",
    y: "36",
    width: "3",
    height: "3"
  }), react_1.default.createElement("rect", {
    x: "26",
    y: "36",
    width: "3",
    height: "3"
  })), react_1.default.createElement("path", {
    d: "M24,9c-4.4,0-8,3.6-8,8c0,4.4,3.6,8,8,8s8-3.6,8-8C32,12.6,28.4,9,24,9z M22.7,20.9l-0.6-0.6l-0.6-0.6L19,17l1.3-1.3\n    l2.5,2.6l5-5.2l1.3,1.3L22.7,20.9z"
  }));
};
exports.OrganisationType = OrganisationType;